import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import {
  andWhere,
  buildQuery,
  Ops,
  orderBy,
  OrderVariant,
  orWhere,
  page,
  select,
  where,

} from "@albatrosdeveloper/ave-utils-npm/lib/utils/query.util";
import { HttpClient } from "@angular/common/http";
import {
  IPagination,
  IPaginationResult,
  IRequestResult,
} from "../../../../common/interfaces";
import { ICreateTenant } from "./interfaces/create-tenant.interface";
import { IUpdateTenant } from "./interfaces/update-tenant.interface";
import { environment as env } from "../../../../../environments/environment.prod";
import { StatusEnum } from "@albatrosdeveloper/ave-models-package/lib/enums";
import { AbstractService } from "../../../../services/abstract.service";
import TenantAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/configurations/tenant/tenant.entity";


const apiUrl = env.API_CONFIGURATION_URL;
const moduleName = "tenant";

@Injectable({
  providedIn: "root",
})
export class TenantService extends AbstractService<
  TenantAttributes,
  ICreateTenant,
  IUpdateTenant
> {
  constructor(
    http: HttpClient,
  ) {
    super(apiUrl, moduleName, http);
  }

  /**
   * Pagination
   * @param options Pagination options
   * @returns Paginated data
   */
  findAllWithCount(
    options: IPagination<TenantAttributes>
  ): Observable<IPaginationResult<TenantAttributes>> {
    const query = buildQuery<TenantAttributes>(
      where('_deleted', Ops.eq(false)),
      orWhere("name", Ops.like(options.search ?? "", "i")),

      orderBy(
        options.sort ?? "name",
        options.sortDirection == "ASC" ? OrderVariant.Asc : OrderVariant.Desc
      ),
      page(options.currentPage ?? 1, options.limitPerPage ?? 100)
    );

    const API_URL: string =
      apiUrl +
      `api/${moduleName}/withCount?filter=${encodeURIComponent(JSON.stringify(query))}`;
    return this.http.get<IPaginationResult<TenantAttributes>>(API_URL);
  }

  /**
   * Find to combo box
   * @returns Data
   */
  findToComboBox(): Observable<IRequestResult<TenantAttributes[]>> {
    const query = buildQuery<TenantAttributes>(
      where("statusId", StatusEnum.ACTIVE),
      select(["name", "id"]),
      orderBy("id", OrderVariant.Asc)
    );

    const API_URL: string =
      apiUrl +
      `api/${moduleName}/filter?filter=${encodeURIComponent(JSON.stringify(query))}`;
    return this.http.get<IRequestResult<TenantAttributes[]>>(API_URL);
  }
}
